import { Link } from 'react-router-dom'
import { Row } from 'src/shared/components/Semantic/all'
import { Button } from 'src/shared/components/ui/button'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { paths } from 'src/routes/paths'

const navLinkClass =
  'text-[14.5px] text-proposal-ink-soft no-underline transition-colors hover:text-proposal-ink'

/** Site bar from the design (Klayder Design Surface · 03 The proposal), in the live product's style. */
export const ProposalTopBar = ({ showLogin }: { showLogin: boolean }) => {
  const { t } = useLocalization()

  return (
    <header className="flex flex-wrap items-center gap-4 border-b border-proposal-ink/[0.09] px-[5%] py-5">
      <Link
        to={paths.home}
        className="text-lg font-semibold tracking-[-0.02em] text-proposal-ink no-underline"
      >
        Klayder
      </Link>
      <nav className="ml-8 hidden flex-wrap gap-6 md:flex">
        <Link to={paths.allProducts} className={navLinkClass}>
          {t('Catalogue', 'Katalog')}
        </Link>
        <Link to={paths.about} className={navLinkClass}>
          {t('How we work', 'Så jobbar vi')}
        </Link>
      </nav>
      <Row className="ml-auto items-center gap-3.5">
        {showLogin ? (
          <Link to={paths.login} className={navLinkClass}>
            {t('Log in', 'Logga in')}
          </Link>
        ) : null}
        <Button
          asChild
          variant="primaryOrange"
          size="md"
          className="px-5 text-sm font-semibold no-underline"
        >
          <Link to={paths.home}>{t('Get a proposal', 'Få ett förslag')}</Link>
        </Button>
      </Row>
    </header>
  )
}
